import React from 'react';
import { Box, IconButton } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';

const DialogHeaderWithBack = ({ title, onBack }) => (
  <Box display="flex" gap="8px" alignItems="center">
    <IconButton
      onClick={onBack}
      aria-label="back"
      sx={{
        padding: 0,
        width: '24px',
        height: '24px',
        color: COLOR.navyBlue,
      }}
    >
      <ArrowBackRoundedIcon sx={{ fontSize: 24 }} />
    </IconButton>
    <Typography variant="body-20-bold" color={COLOR.darkGray}>
      {title}
    </Typography>
  </Box>
);

export default DialogHeaderWithBack;
